import { defineMessages } from 'react-intl';

export const messages: {
	firstSnippetCreatedModalTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	firstSnippetCreatedModalSubtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	firstSnippetCreatedModalCloseButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	firstSnippetCreatedModalViewButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	firstSnippetCreatedModalOkButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	firstSnippetCreatedModalTitle: {
		id: 'snippets.firstSnippetCreatedModalTitle',
		defaultMessage: 'Nice! You created your first template.',
		description:
			'Title for the celebration modal shown after a user creates their first block template',
	},
	firstSnippetCreatedModalSubtitle: {
		id: 'snippets.firstSnippetCreatedModalSubtitle',
		defaultMessage: 'Type "/template" or favorite templates for quick access.',
		description:
			'Subtitle explaining how to access templates via the quick insert menu or favorites',
	},
	firstSnippetCreatedModalCloseButton: {
		id: 'snippets.firstSnippetCreatedModalCloseButton',
		defaultMessage: 'Close',
		description: 'Close button label for the first snippet created celebration modal',
	},
	firstSnippetCreatedModalViewButton: {
		id: 'snippets.firstSnippetCreatedModalViewButton',
		defaultMessage: 'View my template',
		description:
			'Primary button label in the first snippet created celebration modal that dismisses the modal',
	},
	firstSnippetCreatedModalOkButton: {
		id: 'snippets.firstSnippetCreatedModalOkButton',
		defaultMessage: 'Ok',
		description:
			'Primary button label shown in VIEW mode in the first snippet created celebration modal',
	},
});
